export default {
  name: 'main-panel',
  props: {},
};
